import { NextRouter } from "next/router"
import { InitGuideProps } from "@/types/inspiration"
import { createAsyncThunk } from "@reduxjs/toolkit"

import { buildClientAxios } from "@/lib/client-axios"
import inspirationSlice from "@/lib/storage/inspiration-slice"
import { AppDispatch, RootState } from "@/lib/storage/redux-store"
import userSlice from "@/lib/storage/user-slice"
import { toastManager } from "@/lib/toast"
import { sendAnalyticsEvent } from "../analytics/amplitude-utils"
import { UserApi } from "../user-api"

const clientAxios = buildClientAxios()
const userApi = new UserApi(clientAxios)

export const initCreate = createAsyncThunk<
  void,
  void,
  { dispatch: AppDispatch; state: RootState }
>("inspirationSlice/initGuide", async (_, { dispatch }) => {
  const userProfile = await userApi.fetchUserProfile()
  dispatch(userSlice.actions.setUserProfile(userProfile))
  sendAnalyticsEvent("ViewCreatePage")
})

export const initGuide = createAsyncThunk<
  void,
  InitGuideProps,
  { dispatch: AppDispatch; state: RootState }
>("inspirationSlice/initGuide", async (pageProps, { dispatch }) => {
  dispatch(inspirationSlice.actions.setCurrInspiration(pageProps.guide))

  // Don't send amplitude event here. initGuide is called by /admin or the guide page.
  // In the admin case, we get "ViewAdminPage" and then follow by "ViewGuidePage" (wrong)
  // because it is called here.  Move this to guide component instead.
  // sendAnalyticsEvent("ViewGuidePage")
})

export const initInspiration = createAsyncThunk<
  void,
  { error?: string; router: NextRouter },
  { dispatch: AppDispatch; state: RootState }
>("inspirationSlice/initInspiration", async ({ error, router }) => {
  if (error) {
    void router.replace(
      {
        query: null,
      },
      undefined,
      { shallow: true }
    )
    setTimeout(() => {
      toastManager.add({ type: "error", description: error })
      console.log("Error loading guide: ", error)
    }, 500)
  } else {
    sendAnalyticsEvent("ViewInspirationPage")
  }
})
